
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"27","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 20.875a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5z","fill":"#37474F"}}),_c('path',{attrs:{"d":"M18.75 6.134l-.884-.884L1.25 21.866l.884.884 6.676-6.676a3.71 3.71 0 013.756.825l.884-.884a4.98 4.98 0 00-3.203-1.378l2.117-2.117a7.494 7.494 0 012.853 1.728l.883-.884a8.735 8.735 0 00-2.766-1.814l1.873-1.873a11.21 11.21 0 012.659 1.922l.884-.885a12.513 12.513 0 00-2.619-1.962l2.619-2.618zM9.175 12.174l1.276-1.276c-.151-.009-.3-.023-.451-.023a8.716 8.716 0 00-6.107 2.496l.884.883a7.482 7.482 0 014.398-2.08zM10 8.375c.892.003 1.78.114 2.645.328l1.027-1.026A12.471 12.471 0 001.25 10.713v.014l.877.877A11.2 11.2 0 0110 8.375z","fill":"#37474F"}}),_c('path',{attrs:{"d":"M20.333 7.333H19v-4h1.333v4zm0 2.667H19V8.667h1.333V10zm-.666-10A6.67 6.67 0 0013 6.667a6.67 6.67 0 006.667 6.666 6.669 6.669 0 006.666-6.666A6.669 6.669 0 0019.667 0z","fill":"#D32F2F"}})])
          )
        }
      }
    